import { toast } from 'react-toastify';
import * as api from '../api/eventsApi';
import * as events from '../constants/eventConstants';

export const createEventAction = (event) => async () => {
  try {
    const { error } = await api.createEvent(event);
    if (error) {
      throw new Error(error);
    }
    toast.success('Нова подія додана');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати подію');
  }
};

export const updateEventAction = (eventId, event) => async () => {
  try {
    const { error } = await api.updateEvent(eventId, event);
    if (error) {
      throw new Error(error);
    }
    toast.success('Подію було змінено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити подію');
  }
};

export const deleteEventAction = (eventId) => async () => {
  try {
    const { error } = await api.deleteEvent(eventId);
    if (error) {
      throw new Error(error);
    }
    toast.success('Подію було видалено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося видалити подію');
  }
};

export const getMyEventsAction = (date) => async (dispatch) => {
  dispatch({ type: events.GET_EVENTS_REQUEST });
  try {
    const { error, data } = await api.getMyEvents(date);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: events.GET_EVENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити список подій');
    dispatch({ type: events.GET_EVENTS_FAILURE });
  }
};

export const setEventsDateAction = (date) => async (dispatch) => {
  dispatch({
    type: events.SET_EVENTS_DATE,
    payload: date,
  });
};

export const clearEventsAction = () => async (dispatch) => {
  dispatch({
    type: events.CLEAR_EVENTS,
  });
};

export const setSelectedEventAction = (event) => async (dispatch) => {
  dispatch({
    type: events.SELECT_EVENT,
    payload: event,
  });
};

export const clearSelectedEventAction = () => async (dispatch) => {
  dispatch({
    type: events.CLEAR_SELECTED_EVENT,
  });
};
